export default __webpack_public_path__ + "media/zurb/img/events/wired/raft/raft-2-e102b2b7855d0a366e42a4a8b5f9ff4f.png";